<template>
  <LoadingFilters v-if="loadingFilters" />
  <v-list dense v-else>
    <v-list-item>
      <span class="headline">Filtros</span>
      <v-icon class="ml-2" color="secondary">mdi-tune</v-icon>
      <v-spacer />
      <v-btn icon @click="refreshPressed()">
        <v-icon class="pl-1" style="width: 100%;" small>mdi-refresh </v-icon>
      </v-btn>
    </v-list-item>
    <v-divider />
    <v-list-item-group>
      <v-list-item v-if="role === 'admin'">
        <v-list-item-content class="pl-1">
          <v-btn
            dark
            :color="showLeadsDuplicates ? 'blue-grey darken-4' : 'grey'"
            @click="
              () => {
                showLeadsDuplicates = !showLeadsDuplicates;
              }
            "
          >
            Duplicados
          </v-btn>
        </v-list-item-content>
      </v-list-item>
      <v-list-item color="transparent">
        <v-list-item-content>
          <DateRangeComponent
            dense
            ref="dateRange"
            v-model="rangeDate"
            label="Filtrar por fechas"
          />
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="role === 'admin'" color="transparent">
        <v-list-item-content class="pl-1">
          <v-select
            dense
            :items="setContactBrokerNames(filtersSt.contacts)"
            label="Seleccionar broker"
            :menu-props="menuProps"
            v-model="filterBrokers"
          >
            <template #item="{ item, on, attrs }">
              <v-list-item v-on="on" v-bind="attrs">
                <v-list-item-avatar>
                  <AvatarBroker :src="item.avatar" :alt="item.text" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="role === 'admin'" color="transparent">
        <v-list-item-content class="pl-1">
          <v-select
            dense
            :items="setContactBrexNames(filtersSt.externalBrokers)"
            label="Seleccionar broker Externo"
            :menu-props="menuProps"
            v-model="filterBrex"
          ></v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="role !== 'marketing' || role !== 'marketingv2'"
        color="transparent"
      >
        <v-list-item-content
          class="pl-1"
          v-if="showDiscardedLeads || showDiscardedAndActiveLeads"
          @click="dialogPhasesHelper = true"
        >
          <v-select
            dense
            disabled
            :items="filtersSt.phases"
            label="Deshabilitado"
            item-value="data"
            :menu-props="menuProps"
            v-model="filterLeadStatus"
          ></v-select>
          <v-dialog v-model="dialogPhasesHelper" max-width="350">
            <v-card>
              <v-card-title class="title">
                Filtro por Fases deshabilitado.
              </v-card-title>

              <v-card-text>
                No puedes seleccionar una fase cuando el filtro "Mostrar
                Activos, Finalizados y Descartados" o Cuando el filtro "Mostrar
                solo descartados" esta habilitado.
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn text @click="dialogPhasesHelper = false">
                  Cerrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-list-item-content>
        <v-list-item-content class="pl-1" v-else>
          <v-select
            dense
            :items="filtersSt.phases"
            label="Filtrar por fase"
            item-value="data"
            :menu-props="menuProps"
            v-model="filterLeadStatus"
          ></v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item color="transparent">
        <v-list-item-content class="pl-1">
          <!-- Se incluye un botón para poder invertir la selección -->
          <v-autocomplete
            dense
            :items="setSourceName(filtersSt.sources)"
            label="¿Cómo nos encontró?"
            item-text="name"
            return-object
            multiple
            chips
            :menu-props="menuProps"
            v-model="filterHowDidContactUs"
          >
            <template #item="{ item, on, attrs }">
              <v-list-item v-on="on" v-bind="attrs">
                <v-checkbox
                  :value="item.name"
                  :input-value="filterHowDidContactUs.map(i => i.name)"
                />
                <v-list-item-avatar>
                  <v-img
                    contain
                    :src="item.media?.src"
                    width="25px"
                    height="25px"
                  >
                  </v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
                <v-icon
                  :key="`icon-${isEditing}`"
                  @click="
                    filterHowDidContactUs = invertSelection(
                      setSourceName(filtersSt.sources),
                      filterHowDidContactUs
                    )
                  "
                  v-text="isEditing ? 'mdi-find-replace' : 'mdi-find-replace'"
                ></v-icon>
              </v-slide-x-reverse-transition>
            </template>

            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text text-caption">
                (+{{ filterHowDidContactUs.length - 1 }} más)
              </span>
            </template>
          </v-autocomplete>
        </v-list-item-content>
      </v-list-item>
      <v-list-item color="transparent">
        <v-list-item-content class="pl-1">
          <v-autocomplete
            dense
            :items="setMediumName(filtersSt.mediums)"
            label="¿Cómo nos contactó?"
            item-text="name"
            return-object
            multiple
            chips
            :menu-props="menuProps"
            v-model="filterWhereDidContactUs"
          >
            <template #item="{ item, on, attrs }">
              <v-list-item v-on="on" v-bind="attrs">
                <v-checkbox
                  :value="item.name"
                  :input-value="filterWhereDidContactUs.map(i => i.name)"
                />
                <v-list-item-avatar>
                  <v-img
                    contain
                    :src="item.media?.src"
                    width="25px"
                    height="25px"
                  >
                  </v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text text-caption">
                (+{{ filterWhereDidContactUs.length - 1 }} más)
              </span>
            </template>
          </v-autocomplete>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="role !== 'broker'" color="transparent">
        <v-list-item-content class="pl-1">
          <v-select
            dense
            :items="filtersSt.zones"
            label="Llegó por"
            v-model="filterZones"
            multiple
            :menu-props="menuProps"
          ></v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="categoriesItems.length > 0" color="transparent">
        <v-list-item-content class="pl-1">
          <LeadSelectCategory
            :categories="categoriesItems"
            v-model="filterCategory"
          />
        </v-list-item-content>
      </v-list-item>
      <div class="px-4 py-2">
        <p class="ma-0 pa-0 pb-1 theme--light v-label">
          Tipo de registro
        </p>
        <div style="display: flex; justify-content: center;">
          <v-btn-toggle v-model="filterTypeRegister" rounded>
            <!-- Botón 1 -->
            <v-btn
              v-for="option in [
                { text: 'Manual', value: 'manual' },
                { text: 'Automatico', value: 'automatic' }
              ]"
              :key="option.value"
              :value="option.value"
              small
            >
              {{ option.text }}
            </v-btn>
          </v-btn-toggle>
        </div>
      </div>
      <div class="px-4 py-2">
        <p class="ma-0 pa-0 pb-1 theme--light v-label">
          Idioma
        </p>
        <div style="display: flex; justify-content: center;">
          <v-btn-toggle v-model="filterTypeLanguage" rounded>
            <!-- Botón 1 -->
            <v-btn
              v-for="option in [
                { text: 'Español', value: 'Español' },
                { text: 'Inglés', value: 'Inglés' }
              ]"
              :key="option.value"
              :value="option.value"
              small
            >
              {{ option.text }}
            </v-btn>
          </v-btn-toggle>
        </div>
      </div>
      <v-list-item v-if="showZoomFilter" color="transparent">
        <v-list-item-content class="pa-0 pb-1">
          <SimpleSwitch
            v-model="filterZoomCollected"
            label="Agendó Zoom"
            hint="Leads que tienen Zoom agendado"
          />
        </v-list-item-content>
      </v-list-item>
      <template v-if="Object.keys(filtersSt.custom_fields).length > 0">
        <v-divider class="mx-4" />
        <CustomFilterRenderer
          style="display: flex; flex-direction: column; gap: 0.5rem; margin: 0.5rem 1rem;"
          :filters="filtersSt.custom_fields"
          :initialValues="filtersSelectedSt.custom_fields"
          @update:customFields="updateCustomFieldsSt"
        />
        <v-divider class="mx-4" />
      </template>
      <v-list-item
        v-if="role === 'marketing' || role === 'marketingv2'"
        color="transparent"
      >
        <v-list-item-content class="pl-1">
          <v-select
            v-model="searchCampaignFilter"
            dense
            :items="setCampaigns(filtersSt.campaigns)"
            label="Campaña"
            :menu-props="menuProps"
          ></v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="role === 'marketing' || role === 'marketingv2'"
        color="transparent"
      >
        <v-list-item-content class="pl-1">
          <v-select
            v-model="searchConjuntoFilter"
            dense
            :items="setAdSets(filtersSt.adSets)"
            label="Conjunto"
            :menu-props="menuProps"
          ></v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="role === 'marketing' || role === 'marketingv2'"
        color="transparent"
      >
        <v-list-item-content class="pl-1">
          <v-select
            v-model="searchAnuncioFilter"
            dense
            :items="setAds(filtersSt.ads)"
            label="Anuncio"
            :menu-props="menuProps"
          ></v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="role === 'marketing' || role === 'marketingv2'"
        color="transparent"
      >
        <v-list-item-content class="pl-1">
          <v-select
            v-model="searchFormularioFilter"
            dense
            :items="setForms(filtersSt.forms)"
            label="Formulario"
            :menu-props="menuProps"
          ></v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="role !== 'marketing' || role !== 'marketingv2'"
        color="transparent"
      >
        <v-list-item-content class="pa-0 pb-1">
          <SimpleSwitch
            v-model="showReasignedLeads"
            label="Reasignados"
            hint="Leads que han sido asignados de un broker a otro"
          />
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="role !== 'marketing' || role !== 'marketingv2'"
        color="transparent"
      >
        <v-list-item-content class="pa-0 pb-1">
          <SimpleSwitch
            v-model="showDelayedLeads"
            label="Requieren atención"
            hint="Leads que ya superaron el tiempo establecido para ser atendidos"
            color="error"
          />
        </v-list-item-content>
      </v-list-item>
      <v-list-item color="transparent">
        <v-list-item-content class="pa-0 pb-1">
          <SimpleSwitch
            v-model="showDiscardedAndActiveLeads"
            label="Activos, Finalizados y Descartados"
            hint="Mostrar todos los leads, (activos, finalizados y descartados)"
            color="secondary"
          />
        </v-list-item-content>
      </v-list-item>
      <v-list-item color="transparent">
        <v-list-item-content class="pa-0 pb-1">
          <SimpleSwitch
            v-model="showDiscardedLeads"
            label="Descartados"
            hint="Mostrar solo los leads marcados como descartados"
            color="secondary"
          />
        </v-list-item-content>
      </v-list-item>
      <ThermometerProbability v-model="filterProfiles" />
    </v-list-item-group>
  </v-list>
</template>
<script>
import moment from "moment";
import { mapState, mapActions, mapMutations } from "vuex";
import { ZOOM_COLLECT_REAL_ESTATE_GROUP_IDS } from "@/constants/integrations/zoom";

moment.locale("es");

export default {
  components: {
    LoadingFilters: () =>
      import("@/components/layouts/filters/components/LoadingFilters.vue"),
    ThermometerProbability: () =>
      import("./components/ThermometerProbability.vue"),
    // SimpleHelperMsg: () => import("../../common/SimpleHelperMsg.vue"),
    SimpleSwitch: () => import("../../common/SimpleSwitch.vue"),
    DateRangeComponent: () =>
      import("../../reports-kpis/component/dateRange.component.vue"),
    CustomFilterRenderer: () => import("./components/CustomFilterRenderer.vue"),
    AvatarBroker: () => import("@/components/lead/components/avatarBroker.vue"),
    LeadSelectCategory: () =>
      import("@/components/lead/components/LeadSelectCategory/index.vue")
  },
  data: () => ({
    role: localStorage.getItem("user_role"),
    dialogPhasesHelper: false,
    loadingFilters: false,
    initActions: [],
    menuProps: {
      auto: true,
      bottom: true,
      offsetY: true,
      closeOnClick: true
    },
    isEditing: false
  }),
  computed: {
    ...mapState({
      preferencesSt: state => state.preferences,
      filtersSt: state => state.leads.filter.filters || {},
      realEstateGroup: state => state.realEstateGroup.realEstateGroup,
      filtersSelectedSt: state => state.leads.filter.filtersSelected,
      filtersSelectedChangedSt: state =>
        state.leads.filter.filtersSelectedChanged
    }),
    showZoomFilter() {
      return ZOOM_COLLECT_REAL_ESTATE_GROUP_IDS.includes(
        this.realEstateGroup?._id
      );
    },
    filterZoomCollected: {
      get() {
        return !!this.$store.state.leads.filter.customFields?.zoom;
      },
      set(newValue) {
        this.updateCustomFieldsSt({ key: "zoom", value: newValue });
      }
    },
    categoriesItems() {
      const categories = this.filtersSt.categories;
      if (!categories.length) return [];

      return [
        ...categories,
        {
          _id: "N/A",
          code: "N/A",
          description: "Sin perfilar",
          color: "grey"
        }
      ];
    },
    someFilterSelected: {
      get() {
        return this.$store.state.leads.filter.filterSomeFilterSelected;
      },
      set(newValue) {
        this.$store.commit(
          "leads/filter/setfilterSomeFilterSelected",
          newValue
        );
      }
    },
    showLeadsDuplicates: {
      get() {
        return this.$store.state.leads.filter.filterShowLeadsDuplicates;
      },
      set(newValue) {
        this.$store.commit(
          "leads/filter/setfilterShowLeadsDuplicates",
          newValue
        );
      }
    },
    showDiscardedLeads: {
      get() {
        return this.$store.state.leads.filter.filterShowDiscarded;
      },
      set(newValue) {
        // al activar el filtro descartados, deshabilitar filtro requieren atención
        if (newValue) this.showDelayedLeads = false;
        this.$store.commit("leads/filter/setFilterShowDiscarded", newValue);
      }
    },
    showDiscardedAndActiveLeads: {
      get() {
        return this.$store.state.leads.filter.filterShowDiscardedAndActive;
      },
      set(newValue) {
        // al activar el filtro descartados, deshabilitar filtro requieren atenció
        this.$store.commit(
          "leads/filter/setFilterShowDiscardedAndActive",
          newValue
        );
      }
    },
    showDelayedLeads: {
      get() {
        return this.$store.state.leads.filter.filterShowDelayedLeads;
      },
      set(newValue) {
        // al activar el filtro de requieren atención, deshabilitar filtro descartados
        this.$store.commit("leads/filter/setFilterShowDelayed", newValue);
      }
    },
    rangeDate: {
      get() {
        const range = {
          start: this.$store.state.leads.filter.filterInitDateCreateAt,
          end: this.$store.state.leads.filter.filterEndDateCreateAt
        };
        return range;
      },
      set(newValue) {
        this.$store.commit(
          "leads/filter/setFilterInitDateCreateAt",
          newValue.start
        );
        this.$store.commit(
          "leads/filter/setFilterEndDateCreateAt",
          newValue.end
        );
      }
    },
    filterProfiles: {
      get() {
        return this.$store.state.leads.filter.filterProfiles;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setFilterProfiles", newValue);
      }
    },
    filterBrokers: {
      get() {
        return this.$store.state.leads.filter.filterBrokers;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setFilterBrokers", newValue);
      }
    },
    filterBrex: {
      get() {
        return this.$store.state.leads.filter.filterBrex;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setFilterBrex", newValue);
      }
    },
    filterLeadStatus: {
      get() {
        return this.$store.state.leads.filter.filterLeadStatus;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setFilterLeadStatus", newValue);
      }
    },
    filterHowDidContactUs: {
      get() {
        return this.$store.state.leads.filter.filterHowDidContactUs;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setFilterHowDidContactUs", newValue);
      }
    },
    filterWhereDidContactUs: {
      get() {
        return this.$store.state.leads.filter.filterWhereDidContactUs;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setFilterWhereDidContactUs", newValue);
      }
    },
    filterZones: {
      get() {
        return this.$store.state.leads.filter.filterZones;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setFilterZones", newValue);
      }
    },
    filterTypeRegister: {
      get() {
        return this.$store.state.leads.filter.typeRegister;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setTypeRegister", newValue);
      }
    },
    filterTypeLanguage: {
      get() {
        return this.$store.state.leads.filter.typeLanguage;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setTypeLanguage", newValue);
      }
    },
    searchCampaignFilter: {
      get() {
        return this.$store.state.leads.filter.filterCampaign;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setFilterCampaign", newValue);
      }
    },
    searchConjuntoFilter: {
      get() {
        return this.$store.state.leads.filter.filterConjunto;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setFilterConjunto", newValue);
      }
    },
    searchAnuncioFilter: {
      get() {
        return this.$store.state.leads.filter.filterAnuncio;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setFilterAnuncio", newValue);
      }
    },
    searchFormularioFilter: {
      get() {
        return this.$store.state.leads.filter.filterFormulario;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setFilterFormulario", newValue);
      }
    },
    showReasignedLeads: {
      get() {
        return this.$store.state.leads.filter.showReassigned;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setShowReassigned", newValue);
      }
    },
    filterCategory: {
      get() {
        return this.$store.state.leads.filter.filterCategory;
      },
      set(newValue) {
        this.$store.commit("leads/filter/setFilterCategory", newValue);
      }
    }
  },
  mounted() {
    this.loadingFilters = true;
    this.fetchGetLeadsFiltersSt().then(value => {
      this.loadingFilters = false;
      this.initActions.push({
        text: "Desde el inicio",
        tooltip: "La fecha del primer Leads que ingreso al sistema.",
        date: value.firstDate,
        onClick: () => {
          return moment(value.firstDate).format();
        }
      });
    });
  },
  methods: {
    ...mapMutations({
      setLeadsTableFooterSt: "leads/setLeadsTableFooter",
      setFiltersSelectedSt: "leads/filter/setFiltersSelected",
      setClearFiltersSt: "leads/filter/setClearFilters"
    }),
    ...mapActions({
      fetchGetLeadsFiltersSt: "leads/filter/fetchGetLeadsFilters",
      fetchLeadsleadsPaginationSt: "leads/fetchLeadsPagination",
      fetchGetLeadsKanbanByPhaseSt: "leads/fetchGetLeadsKanbanByPhase",
      updateCustomFieldsSt: "leads/filter/updateCustomFields"
    }),
    setSourceName(list) {
      return list.map(item => {
        return item.source;
      });
    },
    setMediumName(list) {
      return list.map(item => {
        return item.medium;
      });
    },
    setContactBrokerNames(contacts) {
      const list = contacts
        ?.filter(e => e.status !== 0)
        .map(({ name, _id, media }) => {
          return { text: name, value: _id, avatar: media?.featured_image?.src };
        });
      list.push({ text: "Todos", value: "all" });
      return list;
    },
    setContactBrexNames(contacts) {
      const list = contacts
        .map(({ name, _id }) => {
          return { text: name, value: _id };
        })
        .sort((a, b) => a.text.localeCompare(b.text));
      list.push({ text: "Todos", value: "all" });
      return list;
    },
    setCampaigns(items) {
      return items.filter(e => {
        return e !== "" && e.trim() !== "";
      });
    },
    setAdSets(items) {
      return items.filter(e => {
        return e !== "" && e.trim() !== "";
      });
    },
    setAds(items) {
      return items.filter(e => {
        return e !== "" && e.trim() !== "";
      });
    },
    setForms(items) {
      return items.filter(e => {
        return e !== "" && e.trim() !== "";
      });
    },
    mktFilter(mktString, param) {
      // comprobar que exista el string mkt
      if (!mktString) return " - ";
      let findParam = param;
      // solo el campo Campaña no tiene '|' al principio
      if (param !== "Campaña") findParam = `| ${param}`;
      // revisar que exista el parametro en el string mkt
      const index = mktString.indexOf(findParam);
      if (index < 0) return " - ";
      let startPos = index + param.length + 2;
      if (param !== "Campaña") startPos += 2; // aumentar otros 2 por separador '|'
      // encontrar el siguiente delimitador '|'
      const indexDelimiter =
        mktString.indexOf("|", startPos) > 0
          ? mktString.indexOf("|", startPos)
          : mktString.length;
      return mktString.substring(startPos, indexDelimiter).trim();
    },
    refreshPressed() {
      this.someFilterSelected = false;
      this.showLeadsDuplicates = false;
      this.showDiscardedLeads = false;
      this.showDiscardedAndActiveLeads = false;
      this.showDelayedLeads = false;
      this.filterProfiles = "";
      this.filterBrokers = "";
      this.filterBrex = "";
      this.filterLeadStatus = null;
      this.filterHowDidContactUs = "";
      this.filterWhereDidContactUs = "";
      this.filterZones = [];
      this.searchCampaignFilter = "";
      this.searchConjuntoFilter = "";
      this.searchAnuncioFilter = "";
      this.searchFormularioFilter = "";
      this.rangeDate = {
        start: null,
        end: null
      };
      this.$refs.dateRange.resetDateRange();
      this.filterTypeRegister = undefined;
      this.filterTypeLanguage = undefined;
      this.showReasignedLeads = false;
      this.filterZoomCollected = false;
      this.setClearFiltersSt(true);
      if (this.preferencesSt && this.preferencesSt.showKanbanFirst) {
        this.refreshLeadsKanban();
      } else {
        this.refreshLeadsTable();
      }
    },
    refreshLeadsTable() {
      this.setFiltersSelectedSt({});
      this.setLeadsTableFooterSt(null);
      this.fetchLeadsleadsPaginationSt({
        filter: this.filtersSelectedSt,
        page: 0,
        limit: 10,
        footer: this.leadsTableFooterSt
      });
    },
    refreshLeadsKanban() {
      this.setFiltersSelectedSt({});
      this.setLeadsTableFooterSt(null);
      this.fetchGetLeadsKanbanByPhaseSt({
        filter: this.filtersSelectedSt,
        page: 0,
        phases: this.filtersSt.phases
      });
    },
    invertSelection(items, selected) {
      this.isEditing = !this.isEditing;
      let filter = items.filter(e => !selected.includes(e));
      return filter;
    }
  }
};
</script>
<style scoped>
.container {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.line-bottom {
  margin-left: 60px;
  border-bottom: 1px solid rgb(199, 199, 199) !important;
}
.icon-line {
  margin-bottom: 100px !important;
  padding-bottom: 100px !important;
}
</style>
